import { useWatch } from '../../../contexts';
import { useClauseConditionsFieldPath } from '../fieldPaths/useClauseConditionsFieldPath';

export const useClauseConditionsWatch = () => {
  const fieldPath = useClauseConditionsFieldPath();
  return useWatch({ name: fieldPath });
};
